import { Operator } from '@img-arena/consoles-api-dde'
import { ddeApi } from '@/service/ddeApi'

import { createBaseTableStore } from '../table'
import type { FetchApiArgs, FetchApiResponse } from '../table/table.types'

const fetchApi = async (
  args: FetchApiArgs<object, string, string>
): Promise<FetchApiResponse<Operator>> => {
  const { signal } = args

  const [{ data: userCount }, { data: operators }] = await Promise.all([
    ddeApi.endpoints.users.getUserCountForOperators(signal),
    ddeApi.endpoints.operators.getAllLicensesPeriods(signal)
  ])

  const operatorIDCountMap = userCount.reduce(
    (acc: Record<string, number>, { operatorId, userCount }) => {
      acc[operatorId] = userCount
      return acc
    },
    {}
  )

  const operatorsWithUsersCount = operators.map((operator) => {
    const usersCount = operatorIDCountMap[operator.id] || 0

    return {
      ...operator,
      usersCount
    }
  })

  return {
    content: operatorsWithUsersCount,
    totalElements: operatorsWithUsersCount.length
  }
}

export const useOperatorsStoreDDE = createBaseTableStore({
  storeName: 'DDE Operators',
  fetchApi
})
